module.exports = __webpack_public_path__ + "static/media/ls-1.d2a31223.jpg";